<template>
  <template v-if="isLoggedIn">
    <NavBar/>
  </template>
  <router-view/>
  <UserNotifications :order="orderId"/>
  <div class="modal fade" id="inactivityModal" tabindex="-1" aria-labelledby="inactivityModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="inactivityModalLabel">{{ t('modal.inactivityTitle') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ t('modal.inactivityText') }}</p>
          <p class="text-muted small">{{ t('modal.inactivitySubtext') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ t('buttons.imHere') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, watch, inject, onMounted, onUnmounted} from 'vue';
import {Modal} from 'bootstrap';
import {useI18n} from 'vue-i18n';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import {log} from "@/utils/clientLogger.js";

import NavBar from "@/components/NavBar.vue";
import UserNotifications from "@/components/UserNotifications.vue";

const {t, locale} = useI18n();
const store = useStore();
const route = useRoute();
const socket = inject('$socket');

watch(
    () => store.state.lang.language,
    (newLang) => {
      locale.value = newLang;
    },
    {immediate: true}
);

const isLoggedIn = computed(() => store.getters.isLoggedIn);
const orderId = computed(() => route.params.id ?? null);

let inactivityTimer = null;
let disconnectTimer = null;
let inactivityModal = null;
const INACTIVITY_TIMEOUT = 15 * 60 * 1000;
const DISCONNECT_GRACE_PERIOD = 60 * 1000;

function disconnectUser() {
  if (isLoggedIn.value && socket && socket.connected) {
    log.info('View:App:disconnectUser', {
      'message': 'The user is inactive. Disconnect the socket.'
    });
    socket.disconnect();
  }
}

function showInactivityModal() {
  if (inactivityModal && isLoggedIn.value) {
    inactivityModal.show();
    clearTimeout(disconnectTimer);
    disconnectTimer = setTimeout(disconnectUser, DISCONNECT_GRACE_PERIOD);
  }
}

function resetInactivityTimer() {
  // Якщо користувач повернувся, а сокет відключений - підключаємо його знову
  if (isLoggedIn.value && socket && !socket.connected) {
    log.info("View:App:resetInactivityTimer", {
      'message': 'The user has returned. We connect the socket.'
    });
    socket.connect();
  }

  clearTimeout(inactivityTimer);
  clearTimeout(disconnectTimer);

  if (inactivityModal) {
    const modalElement = document.getElementById('inactivityModal');
    // Перевіряємо, чи вікно справді видиме, перед тим як його ховати
    if (modalElement && modalElement.classList.contains('show')) {
      inactivityModal.hide();
    }
  }

  if (isLoggedIn.value) {
    inactivityTimer = setTimeout(showInactivityModal, INACTIVITY_TIMEOUT);
  }
}

onMounted(() => {
  const modalElement = document.getElementById('inactivityModal');
  if (modalElement) {
    inactivityModal = new Modal(modalElement);
  }

  const activityEvents = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];

  activityEvents.forEach(event => {
    window.addEventListener(event, resetInactivityTimer, true);
  });

  if (socket) {
    socket.on('connect', resetInactivityTimer);
  }

  resetInactivityTimer();
});

onUnmounted(() => {
  clearTimeout(inactivityTimer);
  clearTimeout(disconnectTimer);

  const activityEvents = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
  activityEvents.forEach(event => {
    window.removeEventListener(event, resetInactivityTimer, true);
  });

  if (socket) {
    socket.off('connect', resetInactivityTimer);
  }
});

watch(() => store.getters.userData.id, (newUserId) => {
  if (newUserId && socket && socket.connected) {
    socket.emit('register-user', newUserId);
  }
}, {immediate: true});

if (socket) {
  socket.on('connect', () => {
    const userId = store.getters.userData.id;
    if (userId) {
      // Якщо дані користувача вже є, відправляємо ID на сервер
    }
  });
}
</script>

<style lang="scss">
/* Твій стиль тут */
</style>